const primePtMessages = {
  'prime.title': 'Usuários Prime',
};

export default primePtMessages;
